export const RECEIVE_SUB_ACTIVITIES = 'RECEIVE_SUB_ACTIVITIES';
export const GET_SUB_ACTIVITIES = 'GET_SUB_ACTIVITIES';
export const SET_SUB_ACTIVITY = 'SET_SUB_ACTIVITY';
export const UPDATE_SUB_ACTIVITY = 'UPDATE_SUB_ACTIVITY';
export const DELETE_SUB_ACTIVITY = 'DELETE_SUB_ACTIVITY';
export const FETCH_SUB_ACTIVITIES = 'FETCH_SUB_ACTIVITIES';
